var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChatDocumentDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.454 18.75v46.023C95.454 70.42 90.876 75 85.227 75h-75C4.58 75 0 70.421 0 64.773V10.227C0 4.58 4.579 0 10.227 0h17.046c2.644 0 5.186 1.03 7.09 2.864l5.864 5.659h45c5.649 0 10.227 4.579 10.227 10.227Z",
    fill: "#A6A6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m49.421 53.29 7.342-7.316a2.383 2.383 0 0 0 0-3.395 2.383 2.383 0 0 0-3.395 0l-3.236 3.237V31.395A2.403 2.403 0 0 0 47.737 29a2.403 2.403 0 0 0-2.395 2.395v14.42l-3.237-3.21a2.383 2.383 0 0 0-3.394 0A2.374 2.374 0 0 0 38 44.29c0 .606.237 1.237.71 1.685l7.316 7.316c.448.447 1.053.71 1.684.71.632 0 1.264-.263 1.711-.71Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatDocumentDownload);
export default __webpack_public_path__ + "static/media/icon_chat_document_download.0f5975a93681b4cab1b38a32f222d9a4.svg";
export { ForwardRef as ReactComponent };